import { Component, Input, OnInit } from '@angular/core';
import { TonnageRating } from '../../../model/tonnage/tonnage-rating.model';

@Component({
  selector: 'lms-lms-tonnage-lmto-table',
  templateUrl: './lms-tonnage-lmto-table.component.html',
  styleUrls: ['./lms-tonnage-lmto-table.component.scss']
})
export class LmsTonnageLmtoTableComponent implements OnInit {
  @Input() lmtoTonnageRatings: TonnageRating[] = [];
  @Input() lmtoHeadings: [];

  constructor() { }

  ngOnInit(): void {
  }

}
